import React from 'react';

import { static_payment_policy_path, static_terms_path } from '@routes';

import IconLock from '../../Images/Rebranding/IconLock';

const CANCELLATION_INSTRUCTIONS_URL =
  'https://theinformation.zendesk.com/hc/en-us/articles/218193188-Cancel-subscription';

const Disclosure = () => (
  <div className="mt-24 text-center font-suisse-screen text-disclosure-sm text-grayscale-gray">
    <IconLock className="w-12 text-black" />
    <div className="my-8">We value your privacy and security</div>
    <div>
      By clicking “Subscribe” you agree to our{' '}
      <a className="text-inherit" target="_blank" rel="noreferrer" href={static_terms_path()}>
        Terms of Service
      </a>{' '}
      and our{' '}
      <a
        className="text-inherit"
        target="_blank"
        rel="noreferrer"
        href={static_payment_policy_path()}
      >
        Payment Policy
      </a>
      . Subscriptions will automatically renew{' '}
      <a
        className="text-inherit"
        target="_blank"
        rel="noreferrer"
        href={CANCELLATION_INSTRUCTIONS_URL}
      >
        until canceled
      </a>
      . Prices are subject to change. This site is protected by reCAPTCHA and the Google Privacy
      Policy and Terms of Service apply.
    </div>
  </div>
);

export default Disclosure;
